<template>
    <div class="qualityAuditData">
        <topTit :titUrl="titUrl"></topTit>
        <div class="container">
            <div class="leftBox">
                <!-- <div class="smallTit"><img src="../../images/smallTit_icon.png" alt="">合格证使用趋势</div> -->
                <!-- <leftChart1></leftChart1> -->
                <CanvasContent :index="0" name="char" @click.stop="selectIndex(0)"></CanvasContent>
                
                <div class="smallTit"><img src="../../images/smallTit_icon.png" alt="">主体使用排行</div>
                <!-- <leftChart2></leftChart2> -->
                <CanvasContent :index="7" name="barChart" @click.stop="selectIndex(7)"></CanvasContent>
                <div class="smallTit"><img src="../../images/smallTit_icon.png" alt="">合格证生成记录</div>
                <!-- <div class="tableBox leftTable">
                    <CanvasContent :index="1" name="tableCom" @click.stop="selectIndex(1)"></CanvasContent>
                </div> -->
                <CanvasContent :index="1" name="tableCom" @click.stop="selectIndex(1)"></CanvasContent>
            </div> 
            <div class="midBox">
                <div class="topCount">
                    <div class="item">
                        <p class="tit">追溯产品验证趋势</p>
                        <p class="num">{{countData.proCount||0}}</p>
                        <!-- <CanvasContent :index="0" name="char" @click.stop="selectIndex(0)"></CanvasContent> -->
                    </div>
                    <div class="item">
                        <p class="tit">追溯码数量</p>
                        <p class="num">{{countData.zsmCount||0}}</p>
                    </div>
                    <div class="item">
                        <p class="tit">追溯码生成记录</p>
                        <p class="num">{{countData.smCount||0}}</p>
                    </div>
                </div>
                <div class="mapBox">
                     <CanvasContent :index="5" name="mapChar" @click.stop="selectIndex(5)"></CanvasContent>
                </div>
                <div class="tableBox">                
                    <CanvasContent :index="6" name="tableCom" @click.stop="selectIndex(6)"></CanvasContent>
                </div>
            </div>
            <div class="rightBox">
                <!-- <div class="smallTit"><img src="../../images/smallTit_icon.png" alt="">追溯产品验证趋势</div> -->
                <CanvasContent :index="4" name="char" @click.stop="selectIndex(4)"></CanvasContent>
                <div class="smallTit"><img src="../../images/smallTit_icon.png" alt="">主体使用排行 </div>
                <CanvasContent :index="8" name="barChart" @click.stop="selectIndex(8)"></CanvasContent>
                <div class="smallTit"><img src="../../images/smallTit_icon.png" alt="">追溯码生成纪录</div>
                <CanvasContent :index="3" name="tableCom" @click.stop="selectIndex(3)"></CanvasContent>
                <!-- <div class="tableBox">
                    <div class="header">
                        <div class="cell">批次编号</div>
                        <div class="cell">产品名称</div>
                        <div class="cell">生成数</div>
                        <div class="cell">生成日期</div>
                        <div class="cell">操作</div>
                    </div>
                    <div class="rowBox">
                        <div class="row" v-for="(item,index) in rightTableData" :key="index">
                            <div class="cell">{{item.retrospPcNum}}</div>
                            <div class="cell">{{item.prdutName}}</div>
                            <div class="cell">{{item.applSl||'0'}}</div>
                            <div class="cell">{{item.createDate?.substring(0, 10)}}</div>
                            <div class="cell">
                                <el-button link type="primary" size="small" @click="openFn(item.retrospNumBh,'zs')">查看</el-button>    
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>  
	</div>
</template>
<script setup>
import { reactive, ref, getCurrentInstance, watch,computed,onMounted } from "vue";


import CanvasContent from "../../components/CanvasPage/CanvasContent"; 
import { useStore } from 'vuex';
import { colorCustomMerge, cloneDeep  } from '../../utils'// 
const { proxy } = getCurrentInstance();
const store = useStore();
const project = ref(computed(() => store.state.project));
const canvasConfig = ref(computed(() => store.state.chartData.canvasConfig));
const componentList = ref(computed(() => store.state.chartData.componentList));
const comChartColors = ref(colorCustomMerge())   //获取选中颜色
const colorkey=ref(canvasConfig.value.theme!=''?canvasConfig.value.theme:'chalk')
const selectIndex = (index)=>{
    project.value.index = index
    selectProject(false)
}
const selectProject = (projectShow)=>{
    project.value.projectShow = projectShow
    store.commit("setProject", project.value);
}
const color =ref(JSON.parse(JSON.stringify(comChartColors.value[colorkey.value].color)))
// 

watch(() => canvasConfig.value.theme,(newVal, oldVal) => {
                if(newVal){
                    color.value =JSON.parse(JSON.stringify(comChartColors.value[canvasConfig.value.theme].color))
                    fn()
                }
            },{ deep: true }

        ) 
//  const chartData =ref([])
const setProjectId = (id) => {
    project.value.id = id
    store.commit("setProject", project.value);
}

 const fn=()=>{
    const  chartData = ref(computed(() => store.state.chartData));
    // store.commit("setChartData", chartData.value);
    const dataFind = (i) => {
    
        proxy
        .$request({
            url: "BIGDATA_BASIC_PRICE_CONFIG_FIND_DETAIL",
            method: "post",
            data: {
                "path": "test/two"
            },
        })
        .then((res) => {
            if (res.data.code == "000") {
                setProjectId(res.data.result.id)
                // console.log(JSON.parse(res.data.result.contents))
                store.commit("setChartData", JSON.parse(res.data.result.contents));
                // 接口请求初始化
                // initRequest()
            }
        })
        .catch((err) => {
            console.log(err);
        });
    }
    dataFind()
    const dataInit = i=>{
            const componentJson = chartData.value.componentList[i]
            if(!componentJson.config.requestConfig.url)return
            let data = {}
            // 基础请求参数处理
            componentJson.config.requestConfig.data.forEach(element => {
                data[element.label] = element.value
            });
            // 全局请求参数处理
            componentJson.config.requestConfig.bindData.forEach(m => {
                let bindJson = chartData.value.requestConfig.data.find(s=>s.label==m.label)
                if(bindJson&&!data[m.label]){
                    data[bindJson.label] = bindJson.value
                }
            });
            proxy
            .$request({
                url: componentJson.config.requestConfig.url,
                method: "post",
                data: data,
            })
            .then((res) => {
                if (res.data.code == "000") {
                    // chartData.value.componentList[i].data = res.data.result
                    // 数据格式不对  数据暂时固定
                    chartData.value.componentList[i].data = {
                        legendData:['层级一','层级二','层级三'],
                        myGraphData : [
                            { "parentNode":"李四", "childNodes":["小明", "蒙恩食品", "阿希达食品", "小a婷","小a妍","小a飞"]},
                        ]
                        } 
                    store.commit("setChartData", chartData.value);
                }
            })
            .catch((err) => {
                console.log(err);
            });
        }
        chartData.value.componentList.forEach((e,index)=>{
            if(e.config.baseConfig.dataFrom=='2'){
                dataInit(index)
            }
        })
 }
 fn()


        const titUrl = '质量监管一张图'
        const dialogFlag = ref(false)
        const leftTableData = ref([])
        const midTableData = ref([])
        const rightTableData = ref([])
        const getLeftTable = ()=>{
            proxy.$request({
                url:"QUALITY_HGCREATELIST",
                method: "post",
                data:{},
            }).then((res)=>{
                if(res.data.code=='000'){
                    leftTableData.value = res.data.result;
                }else{
                    proxy.$alert(res.data.msg || "数据请求失败，请重试", '提示', {
                        confirmButtonText: '确定',
                    });
                }
            }).catch((err)=>{
                console.log(err)
            })
        }
        // getLeftTable()
        const getMidTable = ()=>{
            proxy.$request({
                url:"N_RETRO_CXJLPAGE",
                method: "post",
                data:{},
            }).then((res)=>{
                if(res.data.code=='000'){
                    midTableData.value = res.data.result.list;
                    
                }else{
                    proxy.$alert(res.data.msg || "数据请求失败，请重试", '提示', {
                        confirmButtonText: '确定',
                    });
                }
            }).catch((err)=>{
                console.log(err)
            })
        }
        // getMidTable()
        const getRightTable = ()=>{
            proxy.$request({
                url:"N_RETRO_ZSPCPAGELIST",
                method: "post",
                data:{},
            }).then((res)=>{
                if(res.data.code=='000'){
                    rightTableData.value = res.data.result.list;
                    
                }else{
                    proxy.$alert(res.data.msg || "数据请求失败，请重试", '提示', {
                        confirmButtonText: '确定',
                    });
                }
            }).catch((err)=>{
                console.log(err)
            })
        }
        // getRightTable()
        const countData = ref({
            proCount:'',
            smCount:'',
            zsmCount:''
        })
        const getCountData = ()=>{
            proxy.$request({
                url:"N_RETRO_STATISTICEFORMAP",
                method: "post",
                data:{},
            }).then((res)=>{
                if(res.data.code=='000'){
                    let data = res.data.result;
                    countData.value = data;
                }else{
                    proxy.$alert(res.data.msg || "数据请求失败，请重试", '提示', {
                        confirmButtonText: '确定',
                    });
                }
            }).catch((err)=>{
                console.log(err)
            })
        }
        // getCountData()
        const mapData = ref([])
        const getMapInfo = ()=>{
            proxy.$request({
				url: "N_RETRO_CXJLFORMAP",
				method: "post",
                data: {},
			}).then((res) => {
				if (res.data.code == "000") {
                    let data = res.data.result;
                    mapData.value = data;
				} else {
                    
				}
			}).catch((err)=>{
                console.log(err)
            })
        }
        // getMapInfo()
        const basecollecturl = ref([])
        const openFn = (e,type)=>{
            dialogFlag.value = true
            let currentIp = process.env.VUE_APP_BASE_API +process.env.VUE_APP_PUBLIC_NAME;
            if(type){
                basecollecturl.value =  currentIp + "/sharezs/yy_zs.html?retroCode=" + e ;
            }else{
                basecollecturl.value =  currentIp + "/hgz?id=" + e + "&flag=true";
            }
        }
</script>
<style lang="less">
.customTradeDialog{
    background: transparent;
    box-shadow: none;
    box-sizing: border-box;
    div,p{
        box-sizing: border-box;
    }
    .el-dialog__header {
        display: none !important;
    }
    .el-dialog__body{
        padding: 0;
    }
    .custom-body {
        height: 628px !important;
        background: url("../../images/tradeDialog_bg.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        padding: 0 40px;
        padding-top: 52px;
    }
}
.qualityAuditData {
    *{
        box-sizing: border-box;
        padding: 0;
        margin: 0;
    }
    .hr_2{
        height: 2vh;
    }
	width: 100vw;
	height: 100vh;
    display: flex;
    flex-direction: column;
    background: url(../../images/qualityBg.png) 0 0 no-repeat;
    background-size: 100% 100%;
    .container{
        padding: 1vh 1vw;
        display: flex;
        justify-content: space-between;
        .smallTit{
            font-size: 1vw;
            line-height: 2vh;
            color: #36dbff;
            img{
                width: 1vw;
                height: 2vh;
                margin-right: 0.6vw;
                vertical-align: bottom;
            }
        }
        .tableBox{
            width: 21vw;
            height: 28vh;
            .header{
                width: 100%;
                height: 4vh;
                line-height: 4vh;
                background-color: #003365;
                color: #fff;
                font-family: PingFangSC-Medium;
                font-size: 0.8vw;
                border-bottom:1px solid #0a3957;
                display: flex;
                .cell{
                    cursor: pointer;
                    flex: 1;
                    text-align: center;
                }
            }
            .rowBox{
                height: 24vh;
                overflow: auto;
            }
            .row{
                height: 4vh;
                line-height: 4vh;
                background-color: #001f3e;
                font-family: PingFangSC-Medium;
                font-size: 0.6vw;
                color: #c6dee4;
                border-bottom:1px solid #0a3957;
                display: flex;
                .cell{
                    cursor: pointer;
                    padding: 0 2px;
                    flex: 1;
                    text-align: center;
                    .el-button{
                        width: auto;
                    }
                }
            }
            .rowBox::-webkit-scrollbar { display: none; }
        }
        .midBox{
            width: 100%;
            padding-top: 6vh;
            .topCount{
                display: flex;
                justify-content: space-evenly;
                .item{
                    width: 13vw;
                    height: 4vw;
                    background: url(../../images/zsCount1_bg.png);
                    background-size: 100% 100%;
                    padding-left: 9vh;
                    padding-top: 0.4vh;
                    .tit{
                        color: #36dbff;
                        font-size: 1vw;
                    }
                    .num{
                        font-family: MyBinBold;
                        font-size: 1.6vw;
                        color: #36dbff;
                    }
                }
            }
            .topCount .item:nth-child(2){
                background: url(../../images/zsCount2_bg.png);
                background-size: 100% 100%;
            }
            .topCount .item:nth-child(3){
                background: url(../../images/zsCount3_bg.png);
                background-size: 100% 100%;
            }
            .mapBox{
                height: 46.1vh;
            }
            .tableBox{
                width: 100%;
                .header{
                    height: 5vh;
                    line-height: 5vh;
                    font-size: 0.9vw;
                }
                .rowBox{
                    height: 20vh;
                    .row{
                        font-size: 0.7vw;
                    }
                    .row:hover{
                        background: #0a3957;
                    }
                }
            }
        }
        .leftBox,.rightBox{
            width: 23vw;
            height: 88vh;
            background-color: rgba(0, 0, 0, 0.16);
            padding: 2vh 1vw;
            .smallTit{
                margin-bottom: 1vh;
            }
            .leftTable,.tableBox{
                .header .cell{
                    flex: none;
                }
                .header .cell:nth-child(1){
                    width: 30%;
                }
                .header .cell:nth-child(2){
                    width: 20%;
                }
                .header .cell:nth-child(3){
                    width: 13%;
                }
                .header .cell:nth-child(4){
                    width: 25%;
                }
                .header .cell:nth-child(5){
                    width: 10%;
                }
                .row .cell{
                    flex: none;
                }
                .row .cell:nth-child(1){
                    width: 30%;
                }
                .row .cell:nth-child(2){
                    width: 22%;
                }
                .row .cell:nth-child(3){
                    width: 10%;
                }
                .row .cell:nth-child(4){
                    width: 26%;
                }
                .row .cell:nth-child(5){
                    width: 10%;
                }
            }
        }
    }
}
</style>



  